













































import { defineComponent, ref, useContext, watch } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'
import { usePdpStore } from '~/store/pdp'
import { usePDPNavigationObserver } from '~/composables/pdp/usePDPNavigationObserver'
import { COMPONENTS_IN_NAVIGATION } from '@/common/utils/product/constants'

// Component
import ProtocolText from '@/components/feature/PDP/ProtocolText.vue'
import { Application, StepProtocol } from '~/types/product/productTypes'
import { useProductStore } from '~/store/product'

export default defineComponent({
  components: {
    ProtocolText,
  },
  props: {
    productName: {
      type: String as () => string,
      required: true,
    },
    applications: {
      type: Array as () => Application[] | undefined,
      required: false,
      default: undefined,
    },
    protocols: {
      type: Object as () => { [key: string]: StepProtocol } | undefined,
      required: false,
      default: undefined,
    },
  },
  setup(props) {
    const hasProtocol =
      props.applications
        ?.filter((application) => application.protocol && application.code !== 'E-P')
        .map((application) => {
          const number = application.protocol!.number
          return {
            code: application.code,
            group: application.codeForDisplay,
            application: application.method,
            markup: props.protocols?.[number].markup ?? '',
            number,
          }
        }) ?? []

    const ctx = useContext()
    const isPreviewServer = ctx.$config.cst.isPreview

    const pdpStore = usePdpStore()
    const productStore = useProductStore()
    const { selectedApplication } = storeToRefs(pdpStore)
    const collapsed = ref(false)

    const protocolRef = usePDPNavigationObserver(() => {
      pdpStore.setActiveComponentInNavigation(COMPONENTS_IN_NAVIGATION.PROTOCOLS.ANCHOR)
    })

    const onChange = (event: any) => {
      const value = event.target.value
      if (value.length) {
        const currentProtocol = hasProtocol[event.target.options.selectedIndex - 1]
        pdpStore.setSelectedApplication({
          code: currentProtocol.code,
          group: currentProtocol.group,
          protocolId: currentProtocol.number,
        })
        collapsed.value = false
      } else {
        pdpStore.unsetSelectedApplication()
        collapsed.value = true
      }
    }

    const printProtocol = (protocolId: string) => {
      window.open(
        `/products/include/protocol?productId=${productStore.currentProduct.data.key}&protocolId=${protocolId}`,
        'protocol-print-preview',
        'width=992,height=992'
      )
    }

    watch(selectedApplication, () => {
      collapsed.value = false
    })

    const displayCondition = ref(!!hasProtocol.length)
    if (displayCondition.value) {
      pdpStore.setComponentAsRendered(COMPONENTS_IN_NAVIGATION.PROTOCOLS)
    }

    return {
      displayCondition,
      hasProtocol,
      collapsed,
      onChange,
      printProtocol,
      protocolRef,
      isPreviewServer,
      selectedApplication,
    }
  },
})
